<template>
  <div
    v-if="text"
    class="search-list">
    <router-link
      :to="link"
      @click.native="triggerSearchInitiatedEvent(text)">
      {{ text }}
    </router-link>
  </div>
</template>
<script>
import SegmentEvent from '../services/PlayerEvent';

export default {
  name: 'SearchListing',
  props: {
    text: {
      type: String,
      default: '',
    },
    link: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: '',
    },
    itemData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      eventProvider: new SegmentEvent(),
    };
  },
  methods: {
    triggerSearchInitiatedEvent() {
      if (this.type === 'publisher') {
        this.triggerPublisherContentViewEvent();
        return;
      }

      const searchVariant = this.type === 'trending-search' ? 'trending search' : 'top category';

      const data = {
        screen_name: window.Vue.$route.name,
        autocomplete_position_selected: null,
        search_query: this.text,
        search_variant: searchVariant,
        typed_query: null,
      };
      this.$analytics.track('Search Initiated', data);
    },
    triggerPublisherContentViewEvent() {
      const bucket = {
        name: 'Publishers',
        bucket_uuid: null,
        bucket_type: 'search_publishers',
        media_size: 'text',
        position: 2,
      };
      const bucketItem = {
        item_position: this.$vnode.key, // need to add manually in selected bucket item
        title: this.itemData.name,
        content_selected_uuid: this.itemData.uuid,
      };
      this.eventProvider.triggerContentSelectEvent(bucket, bucketItem, 'search_results_publisher');
    },
  },
};
</script>
<style lang="scss">
@import "../assets/scss/variables.scss" , "../assets/scss/mixins.scss";
.search-list {
  border-bottom: 1px solid $light-gray2;
  background-color: #fefefc;
  a {
    @include multilinetruncate(16px, 18px, 2);
    margin:0 !important;
    color: $black;
    display: block;
    padding: 15px 15px 21px 0 !important;
    transition: .2s all ease-in-out;
  }
  a:hover {
    cursor: pointer;
    transform: translateX(5px);
  }
}
</style>



// WEBPACK FOOTER //
// app/src/components/SearchListing.vue